import { render, staticRenderFns } from "./Integer.vue?vue&type=template&id=994ca866&scoped=true&"
import script from "./Integer.vue?vue&type=script&lang=js&"
export * from "./Integer.vue?vue&type=script&lang=js&"
import style0 from "./Integer.vue?vue&type=style&index=0&id=994ca866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994ca866",
  null
  
)

export default component.exports